/**
 * postcss.config.js中postcss-pxtorem.rootValue 与 src/assets/style/variable.js 中 px→rem 共用基准。
 * 约定：375 设计稿宽度下配合 flexible，`html` 字号为视口宽 / 10，此时 1rem ≈ 37.5px。
 */
module.exports = 37.5
